(function() { module.exports = window["eventespresso"]["predicates"]; }());